var _circle, _path, _path2, _path3, _rect, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentSt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 89,
    viewBox: "0 0 109 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.998,
    cy: 44.5,
    r: 44.5,
    fill: "#FBFCFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1411 45.0232C6.7769 34.4394 14.9296 25.568 26.2112 22.5451C37.4928 19.5222 48.9889 23.1287 56.5635 30.9766C53.9277 41.5604 45.775 50.4318 34.4934 53.4547C23.2118 56.4776 11.7157 52.8711 4.1411 45.0232Z",
    fill: "#E4ECFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9336 51.6584C41.4341 49.6486 45.8853 41.939 43.8755 34.4385C41.8657 26.938 34.1561 22.4868 26.6556 24.4966C19.1551 26.5063 14.7039 34.2159 16.7137 41.7165C18.7234 49.217 26.4331 53.6682 33.9336 51.6584Z",
    fill: "#508AF2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.044 44.6072C35.6503 43.641 37.7904 39.9342 36.8241 36.328C35.8578 32.7217 32.151 30.5816 28.5448 31.5479C24.9386 32.5142 22.7985 36.221 23.7648 39.8272C24.731 43.4334 28.4378 45.5735 32.044 44.6072Z",
    fill: "#1953D5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 63.3813,
    y: 21.7186,
    width: 47,
    height: 47,
    rx: 16,
    transform: "rotate(15 63.3813 21.7186)",
    fill: "#508AF2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9486 51.4621L76.0285 41.7783C75.9043 41.6686 75.7541 41.5925 75.5922 41.557C75.4303 41.5215 75.262 41.528 75.1033 41.5757C74.9445 41.6234 74.8006 41.7108 74.6851 41.8296C74.5695 41.9485 74.4862 42.0948 74.443 42.2548L71.0643 54.8644C71.0217 55.0245 71.0206 55.1929 71.0612 55.3536C71.1019 55.5143 71.1828 55.662 71.2965 55.7826C71.4101 55.9033 71.5527 55.9929 71.7107 56.0431C71.8687 56.0932 72.0369 56.1022 72.1993 56.0692L86.4981 53.1434C86.6751 53.1072 86.8386 53.0223 86.9701 52.8984C87.1016 52.7746 87.1961 52.6165 87.2428 52.4419C87.2896 52.2674 87.2868 52.0833 87.2349 51.9102C87.1829 51.7372 87.0838 51.582 86.9486 51.4621Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentSt);
export default __webpack_public_path__ + "static/media/recent-st.b1d2c8b050d422ba7125e9ec592c16bf.svg";
export { ForwardRef as ReactComponent };